import { render, staticRenderFns } from "./BaseBarChart.vue?vue&type=template&id=53286c3e"
import script from "./BaseBarChart.vue?vue&type=script&lang=js"
export * from "./BaseBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports